import LoaderHOC from './LoaderHOC';
import { connect } from 'react-redux';

// Selectors
import { getServicesLoading } from 'store/reducers/ajaxCall/selectors';

const mapStateToProps = state => {
  return {
    getServicesLoading: getServicesLoading(state)
  };
};

export default connect(mapStateToProps)(LoaderHOC);



// WEBPACK FOOTER //
// ./src/components/atoms/LoaderHOC/LoaderHOCContainer.js